module.exports = __webpack_public_path__ + "static/media/months6.62591cbf.jpg";